import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

const RightArrow: React.FC<IconProps> = (props) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-4 w-4 text-gray-500"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  </>
);

export default RightArrow;
